<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>用户信息详情</span>
      <el-button type="primary"
                 style="width:92px;"
                 size="medium"
                 @click="back">返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <div>
            <el-menu :default-active="activeIndex"
                     class="el-menu-demo noneline"
                     mode="horizontal"
                     @select="handleSelect">
              <el-menu-item index="1"
                            class="title"
                            style="font-size:16px">用户信息</el-menu-item>
              <el-menu-item index="2"
                            class="title space"
                            style="font-size:16px"
                            :disabled="module_id_array[0]?!module_id_array.includes('42'):false">关联患者</el-menu-item>
              <el-menu-item index="3"
                            class="title space"
                            style="font-size:16px"
                            :disabled="module_id_array[0]?!module_id_array.includes('114'):false">处方订单</el-menu-item>
              <el-menu-item index="4"
                            class="title space"
                            style="font-size:16px"
                            :disabled="module_id_array[0]?!module_id_array.includes('787'):false">商品订单</el-menu-item>
            </el-menu>
          </div>
          <div class="box">
            <div class="component">
              <component :is="currentComponent" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserMsg from './UserMsg';
import OrderLog from './OrderLog';
import ConcatPatient from './ConcatPatient';
import GoodsOrder from './GoodsOrder';
export default {
  data() {
    return {
      activeIndex: '1',
      active: ''
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return UserMsg;
        case '2':
          return ConcatPatient;
        case '3':
          return OrderLog;
        case '4':
          return GoodsOrder;
        default:
          return UserMsg;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    },
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>